import { ref } from 'vue'

/**
 * 로그인한 사용자의 API 자격증명 한 곳.
 *
 * 서버 인증은 `x-api-key` + `x-user-email` 뿐이다(authMiddleware). HTTP 헤더와
 * WebSocket 쿼리스트링이 **같은 값**을 써야 하는데, 예전에는 각자 따로 읽었다 —
 * 헤더는 localStorage 를, WS URL 은 빌드타임 env(VITE_DRONECAST_API_KEY)를.
 * 그래서 목록은 보이는데 재생은 "참여 중"에서 멈췄다(WS 가 인증 누락으로 거부됨).
 *
 * localStorage 는 반응형이 아니므로 ref 로 감싸 둔다 — 로그인·로그아웃이
 * refreshStoredAuth() 를 불러 WS URL 까지 같이 갱신되게 한다.
 */
const STORAGE_KEY = 'dronecast_user'

export interface StoredAuth {
  apiKey: string
  userEmail: string
}

function read(): StoredAuth {
  try {
    const u = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null')
    if (u?.apiKey) return { apiKey: String(u.apiKey), userEmail: String(u.userEmail ?? '') }
  } catch {
    /* 깨진 값이면 아래 기본값으로 떨어진다 */
  }
  // 로그인 전 / 개발용 기본값
  return {
    apiKey: (import.meta.env.VITE_DRONECAST_API_KEY as string) || '',
    userEmail: (import.meta.env.VITE_DRONECAST_USER_EMAIL as string) || '',
  }
}

export const storedAuth = ref<StoredAuth>(read())

/** 로그인·로그아웃 직후 호출한다. */
export function refreshStoredAuth(): void {
  storedAuth.value = read()
}

export function getStoredAuth(): StoredAuth {
  return storedAuth.value
}

export function getAuthHeaders(): Record<string, string> {
  const { apiKey, userEmail } = storedAuth.value
  return { 'x-api-key': apiKey, 'x-user-email': userEmail }
}
